export default "__VITE_ASSET__9yhyABAJ__"